import { useDispatch, useSelector } from "react-redux";
import { openCart, closeCart, addToCart } from "../features/cart/cartSlice";
import { fetchSyncCart } from "../features/cart/cartSlice";

export default function useHandleCartDrawer() {
    const dispatch = useDispatch();
    const { user }            = useSelector((state) => state.auth);
    const { isOpen, product } = useSelector((state) => state.cart);

    const openCartDrawer = (item = null) => {
        if (item) {
            dispatch(addToCart(item)); // handles existing qty increase in slice

            // sync to server after adding
            const existing = product.find(
                p => p.product_id === item.product_id &&
                     p.size_id   === item.size_id &&
                     p.flavour   === item.flavour
            );
            const updated = existing
                ? product.map(p =>
                    p.product_id === item.product_id &&
                    p.size_id    === item.size_id &&
                    p.flavour    === item.flavour
                        ? { ...p, qty: (p.qty || 1) + 1 }
                        : p
                  )
                : [...product, { ...item, qty: 1 }];

            if (user) {
                dispatch(fetchSyncCart({
                    userId: user.userId,
                    items: updated.map(p => ({
                        product_id:   p.product_id,
                        product_name: p.name,
                        size_value:   p.size,
                        qty:          p.qty || 1
                    }))
                }));
            }
        }

        dispatch(openCart());
    };

    const closeCartDrawer = () => {
        dispatch(closeCart());
    };

    return {
        isOpen,
        product,
        openCartDrawer,
        closeCartDrawer,
    };
}